import { createRouter, createWebHistory } from 'vue-router'
import isMobilePhone, { getBase } from '../utils/index.js'
const regex = /car\/(.*?)\//;
const match = window.location.href.match(regex);
const isNew = true
const Index = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/Index'):()=>import('../views/mobile/Index'):isNew?()=>import('../views/pc/theme/vx6/Index'):()=>import('../views/pc/Index')
const OutsideView = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/OutsideView'):()=>import('../views/mobile/OutsideView'):()=>import('../views/pc/OutsideView')
const InsideView = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/InsideView'):()=>import('../views/mobile/InsideView'):isNew?()=>import('../views/pc/theme/vx6/InsideView'):()=>import('../views/pc/InsideView')
const OptionsView = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/OptionsView'):()=>import('../views/mobile/OptionsView'):()=>import('../views/pc/OptionsView')
const AssembleView = isMobilePhone()?()=>import('../views/mobile/AssembleView'):()=>import('../views/pc/AssembleView')
const PandectView = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/Pandect'):()=>import('../views/mobile/Pandect'):()=>import('../views/pc/Pandect')
const VersionView = isMobilePhone()?isNew?()=>import('../views/mobile/vx6/VersionView'):()=>import('../views/mobile/VersionView'):()=>import('../views/pc/VersionView')
const HomeView = ()=>import('../views/mobile/Home')
const router = createRouter({
  history: createWebHistory(getBase()),
  routes: [
    {
      path:'/home',
      component:HomeView
    },
    {
      path:'/car/:car',
      component:Index,
      children:[
        {
          path:'',
          name:'version',
          component:VersionView
        },
        {
          path:'outside',
          name:'outside',
          component:OutsideView
        },
        {
          path:'inside',
          name:'inside',
          component:InsideView
        },
        {
          path:'options',
          name:'options',
          component:OptionsView
        },
        {
          path:'assemble',
          name:'assemble',
          component:AssembleView
        },
        {
          path:'pandect',
          name:'pandect',
          component:PandectView
        },
      ]
    },
  ]
})

export default router
